export default __webpack_public_path__ + "static/imgThirteen-5e68e7c14c45dc1721074d1e84d1ecac.jpg";